<template>
  <h3
    class="text-background-fg/70 text-lg font-medium leading-loose"
  >
    <slot />
  </h3>
</template>
